import styled, { css } from 'styled-components';
import COLORS from '../../constants/colors.js';
import { convertHexToRGBA } from '../../methods/convertHexToRGBA.js';
import '../../constants/fonts.js';
import '../../constants/theme.js';
import '../../constants/files.js';
import '../../constants/color-variant.js';
import '../../constants/zIndexList.js';
import { flexCenter } from '../../mixins/style-mixins.js';
import { scrollBarStyle__hidden, scrollBarStyle } from '../../mixins/scrollbar.js';
import '../../mixins/cursor.js';
import '../../mixins/font.js';

const getModalSize = {
    "extra-wide": "968px",
    wide: "800px",
    compact: "600px",
    fit: "fit-content",
    viewport: "90dvw",
};
const ModalOverlayWrapper = styled.div `
    ${flexCenter}
    background-color: ${convertHexToRGBA(COLORS.GREY_1000, 0.6)} !important;
`;
const ModalContentWrapper = styled.div `
    padding: 0 !important;

    position: static !important;
    background: ${COLORS.WHITE} !important;
    box-shadow: 4px 4px 24px ${convertHexToRGBA(COLORS.GREY_1000, 0.2)};
    height: fit-content;
    max-height: var(--viewport-height-p90, calc(100dvh - 10dvh));
    max-width: ${({ size }) => (size === "viewport" ? "90dvw" : "calc(100dvw - 10vw)")};
    width: ${({ size }) => getModalSize[size !== null && size !== void 0 ? size : "wide"]} !important;

    display: flex;
    flex-direction: column;
    border: none !important;
    [data-popup-header] {
        display: flex;
        gap: 5px;
        justify-content: space-between;
        padding: ${({ padded }) => padded && "20px 20px 20px 20px"} !important;
    }
    [data-popup-body] {
        padding: ${({ padded }) => padded && "20px"} !important;
        overflow-y: auto;
        overflow-x: hidden;
        ${({ hideBodyScrollbar }) => hideBodyScrollbar ? scrollBarStyle__hidden : scrollBarStyle}
        flex-grow: 1;
    }
    [data-popup-footer] {
        padding: ${({ padded }) => padded && "20px 20px 20px 20px"} !important;
    }
    ${({ fullScreenModal }) => fullScreenModal &&
    css `
            max-height: none !important;
            max-width: none !important;
            width: 100% !important;
            height: 100% !important;
            padding: 0 !important;
            inset: 0 !important;
        `}
`;
const ModalSectionWrapper = styled.div ``;
const ModalCrossIconWrapper = styled.div `
    ${flexCenter}
    background-color: ${COLORS.GREY_200};
    border-radius: 50%;
    width: 36px;
    height: 36px;
    margin-left: auto;
`;

export { ModalContentWrapper, ModalCrossIconWrapper, ModalOverlayWrapper, ModalSectionWrapper };
//# sourceMappingURL=Modal.styles.js.map
